import colors from 'lib/constants/resourceColors';
import { EST_PALE_GREEN , EST_PALE_RED } from 'lib/constants/colors';
import Privileges from 'lib/constants/privileges';
import { taskFields, taskTableProps } from './tasks';

export default {
    defaults: {
        name: 'Task',
        color: colors.tasks_installation,
        appUrlBase: '/installations/tasks',
    }, 
    search: {
        heading: 'Installation Tasks', 
        cacheKey: 'cache_search_installation_tasks',
        defaultFilter: (currentUser) => { return {task_type: 'INSTALLATION' }},
        allowDateFilter: true,
        fields: taskFields,
        toggleOptions: [
            {key: 'hide_completed', 
                label: 'Hide Completed', 
                param: 'completed', 
                defaultValue: (currentUser) => true, 
                value: (currentUser) => false }
        ],
        searchBy: ['description', 'assigned user', 'creator', 'task parent', 'task type', 'task name or number'], 
        tableProps: taskTableProps, 
    }
}
